import { render, staticRenderFns } from "./niitlelPost.vue?vue&type=template&id=ea01a328&"
import script from "./niitlelPost.vue?vue&type=script&lang=js&"
export * from "./niitlelPost.vue?vue&type=script&lang=js&"
import style0 from "./niitlelPost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports